function formatName(name: string | undefined): string {
  if (!name) return ''
  if (name === 'efax') return 'eFAX'
  return name.toUpperCase()
}

function formatPhoneNumber(description: string | undefined): string {
  if (!description) return ''
  const match = description.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/)
  return match ? `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}` : description
}

export function extractInboxName(inboxName: string) {
  return {
    name: formatName(inboxName.split('/')[0]),
    description: formatPhoneNumber(inboxName.split('/')[1]),
  }
}
